module.exports = __webpack_public_path__ + "static/img/store_phone.133542c0.png";